export const SALES_HISTORY_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export function parseSalesHistoryAsOfDate(value) {
	const matched = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
	if (!matched) return null;

	const year = Number(matched[1]);
	const month = Number(matched[2]);
	const day = Number(matched[3]);
	const as_of_date = new Date(year, month - 1, day);

	if (as_of_date.getFullYear() !== year || as_of_date.getMonth() !== month - 1 || as_of_date.getDate() !== day) return null;

	return as_of_date;
}

function numericAmount(value) {
	if (typeof value === 'string') value = value.replace(/,/g, '');

	const amount = Number(value);
	return Number.isFinite(amount) ? amount : 0;
}

export function buildSalesHistorySummary(rows, reference_date = new Date()) {
	const as_of_date = reference_date instanceof Date && !Number.isNaN(reference_date.getTime()) ? reference_date : new Date();
	const current_year = as_of_date.getFullYear();
	const current_month = as_of_date.getMonth() + 1;
	const target_years = [current_year - 2, current_year - 1, current_year];
	const amounts = {};
	let has_data = false;

	(rows || []).forEach(row => {
		const year = Number(row.year);
		const month = Number(row.month);

		if (!target_years.includes(year) || !Number.isInteger(month) || month < 1 || month > 12) return;

		const key = `${year}-${month}`;
		amounts[key] = (amounts[key] || 0) + numericAmount(row.amount);
		has_data = true;
	});

	const years = target_years.map(year => {
		const months = SALES_HISTORY_MONTHS.map((name, index) => {
			const month = index + 1;
			const is_future = year === current_year && month > current_month;
			return {
				month,
				name,
				amount: is_future ? null : amounts[`${year}-${month}`] || 0,
			};
		});

		return {
			year,
			months,
			total: months.reduce((total, month) => total + (month.amount === null ? 0 : month.amount), 0),
		};
	});

	return {
		current_year,
		current_month,
		years,
		has_data,
	};
}
